<script setup>
  import { useRouter } from 'vue-router'
  import { onMounted, onUnmounted } from 'vue'
  import { addListener, launch } from 'devtools-detector';

  const router = useRouter();
  let removeDevtoolsListener =  null;

  onMounted(async () => {
    //  if (import.meta.env.MODE === 'production') {
    //   removeDevtoolsListener = addListener(isOpen => {
    //     if (isOpen) {
    //       window.location.href = 'https://google.com';
    //     }
    //   });
    //   launch();
    // }
  });

  onUnmounted(() => {
     if (removeDevtoolsListener) {
      removeDevtoolsListener();
    }
  });
</script>
<template>
  <router-view/>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>

